export enum Colors {
  Red = "#d9534f",
  Blue = "#5bc0de",
  Yellow = "#f0ad4e",
  Green = "#5cb85c",
  Pink = "#f7c6f5",
  DarkGrey = "#777",
  LightBlue = "#0288d1",
  DarkRed = "#c73956",
  LightGreen = "#8bc34a",
  Orange = "#ff5722",
  Purple = "#9c27b0",
  Grey = "#607d8b",
  DarkOrange = "#ff9800",
  DarkGrey2 = "#9e9e9e",
  DarkBlue = "#3f51b5",
  DarkRed2 = "#f44336",
  DarkPurple = "#673ab7",
  DarkGreen = "#00bcd4",
  DarkYellow = "#cddc39",
  DarkPink = "#e91e63",
}

export const letterColors: Record<string, Colors> = {
  A: Colors.Red,
  B: Colors.Blue,
  C: Colors.Yellow,
  D: Colors.Green,
  E: Colors.Pink,
  F: Colors.DarkGrey,
  G: Colors.LightBlue,
  H: Colors.DarkRed,
  I: Colors.LightGreen,
  J: Colors.Orange,
  K: Colors.Purple,
  L: Colors.Grey,
  M: Colors.DarkOrange,
  N: Colors.DarkGrey2,
  O: Colors.DarkBlue,
  P: Colors.DarkRed2,
  Q: Colors.DarkPurple,
  R: Colors.DarkGreen,
  S: Colors.DarkYellow,
  T: Colors.LightGreen,
  U: Colors.DarkYellow,
  V: Colors.DarkPink,
  W: Colors.Purple,
  X: Colors.DarkRed2,
  Y: Colors.LightBlue,
  Z: Colors.DarkGreen,
  "#": Colors.DarkGrey2,
  "%": Colors.DarkGrey2,
  ".": Colors.DarkGrey2,
  А: Colors.Red,
};
